export default __webpack_public_path__ + "static/media/credit-icon.aa6804a6.svg";